// LoadingSpinner.jsx
import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const LoadingSpinner = () => {
  return (
    <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    minHeight="100vh" // Ensures it takes up the full screen height
    position="fixed" // Keeps the spinner fixed in view
    top={0}
    left={0}
    right={0}
    bottom={0}
    bgcolor="rgba(255, 255, 255, 0.4)" // Semi-transparent background for overlay effect
    zIndex={9999} // Ensures it stays above other content
    >
      <CircularProgress />
    </Box>
  );
};

export default LoadingSpinner;
